module.exports = __webpack_public_path__ + "img/ic_check_layer3.513cb913.png";